let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7oEYd")).then(() => parcelRequire('7V4xb'));